// itsoftApp.createModule("boxAnim", function () {
//     var module = this;

//     var initboxAnim = function () {
//         var startAnimate = function () {
//             var boxAnim = document.querySelector('.image-box-js');
//             if (boxAnim) {
//                 boxAnim.classList.add('_running');
//             }
//         }
//         setTimeout(startAnimate, 1000);
//     };

//     module.callback = initboxAnim;
// });


itsoftApp.createModule("boxAnim", function () {
    var module = this;

    var initboxAnim = function () {
        var startAnimate = function () {
            var boxAnim = document.querySelector('.image-box-js');
            removeRun();
            setTimeout(addRun, 16000);
            function removeRun() {
                boxAnim.classList.add('_running');
            }
            function addRun(){
                boxAnim.classList.remove('_running')
            }
        }
        startAnimate();
        setInterval(startAnimate, 16500);
    };

    module.callback = initboxAnim;
});
